import { CampaignForm } from "Components/Admin/Campaigns/CampaignForm/CampaignForm";
import { useCreateCampaignMutation } from "Api/Mutations/Admin/useCreateCampaignMutation";
import { useNavigate } from "Navigation/useNavigate";
import { appUrl } from "Utils/UrlUtils";
import { toast } from "sonner";
import type { CampaignFormData } from "Components/Admin/Campaigns/CampaignForm/campaignFormSchema";
import type { ApiProblemDetails } from "Infrastructure/Api/Api";

import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Admin.Campaigns.Messages;

export const CampaignCreateContent = () => {
  const { t } = useResource();
  const navigate = useNavigate();

  const { mutateAsync: createCampaign, isPending } = useCreateCampaignMutation({
    onSuccess: (result) => {
      toast.success(t(RESOURCES.CreateSuccess, { code: result.code }));
      navigate(
        `${appUrl("admin-campaigns-edit")}/${result.campaignID}/edit?activeStep=landing-page`,
      );
    },
    onError: (error: Error) => {
      if (typeof error === "object" && error !== null && "data" in error) {
        const errorData = error.data as Record<string, unknown>;
        if (
          errorData &&
          typeof errorData === "object" &&
          "errors" in errorData
        ) {
          const errors = (errorData as ApiProblemDetails).errors || {};
          if (errors.Code) {
            return toast.error(t(RESOURCES.CodeExistsError));
          }
        }
      }
      return toast.error(t(RESOURCES.CreateError));
    },
  });

  const handleSubmit = async (data: CampaignFormData) => {
    await createCampaign({
      ...data,
      description: data.description || "",
      header: data.header || null,
      linkName: data.linkName || null,
      linkUrl: data.linkUrl || null,
      successfulPaymentText: data.successfulPaymentText || null,
      receiverUserID: data.receiverUserID || null,
      receiverIdentityUserID: data.receiverIdentityUserID ?? null,
      startDate: data.dateMode === "unlimited" ? null : data.startDate || null,
      endDate: data.dateMode === "unlimited" ? null : data.endDate || null,
    });
  };

  return <CampaignForm onSubmit={handleSubmit} isSubmitting={isPending} />;
};
